<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="col-12">
        <!-- Summary -->
        <div class="col-12 nopads pb-3">
            <observation-type-summary
                :observation-types="observationTypes"
            />
        </div>
        <span class="span-title">
            {{ $t('observation_filter.observation_type') }}
        </span>
        <div v-if="observations.length > 0" class="row">
            <div class="col-sm-6">
                <multiselect
                    v-model="selectedObservationTypes"
                    class="multiselect_routa"
                    :placeholder="$t('observation_filter.select_observation_type')"
                    :deselect-label="$t('common.remove_selection')"
                    :select-label="$t('common.select')"
                    :close-on-select="false"
                    :multiple="true"
                    label="name"
                    track-by="id"
                    :searchable="true"
                    :internal-search="true"
                    :selected-label="$t('common.selected')"
                    :options="observationTypes"
                >
                    <template #singleLabel="props">
                        <span class="option__desc">
                            <span class="option__title">{{ props.option.name }}</span>
                        </span>
                    </template>
                    <template #option="props">
                        <div class="option__desc">
                            <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                        </div>
                    </template>
                </multiselect>
            </div>
        </div>
        <div class="col-12 d-flex justify-content-end my-2">
            <button
                :disabled="observations.length < 1"
                class="btn btn-outline-success form-button"
                @click="exportExcel"
            >
                {{ $t('trip.download_excel') }}
            </button>
            <button
              class="btn btn-outline-success form-button"
              :disabled="observations.length < 1"
              @click="exportRoadReport"
            >
              {{ $t('observations.download_road_report') }}
            </button>
        </div>
        <!--Result table-->
        <Transition name="fade">
          <div v-if="tableItems.length > 0" class="col-sm-12 list-content result-table">
              <vue3-datatable
                  ref="resultTable"
                  :rows="tableItems"
                  :columns="fields"
                  :pagination="false"
                  :sticky-header="true"
                  height="50vh"
                  :sortable="true"
                  skin="bh-table-compact"
                  row-class="routa-table-row"
                  cell-class="routa-table-cell"
                  @row-click="onRowClicked"
              >
              </vue3-datatable>
          </div>
        </Transition>
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {vehicleHelper} from '../mixins/VehicleMixin'
import {downloadHelper} from '../mixins/DownloadMixin'
import {timeUtils} from '../mixins/TimeUtils'
import ObservationTypeSummary from "@/components/observation/type/ObservationTypeSummary.vue";
import Vue3Datatable from "@bhplugin/vue3-datatable";
import {inject} from "vue";

export default {
    name: 'ContractObservationsList',
    components: {ObservationTypeSummary, Vue3Datatable},
    mixins: [timeUtils, restApi, vehicleHelper, downloadHelper],
    props: {
        observations: {
            type: Array,
            default() {
                return []
            }
        },
        observationTypes: {
            type: Array,
            default() {
                return []
            }
        },
        params: {
            type: Object,
            default() {
                return null
            }
        },
    },
    data: function () {
        return {
            tableItems: [],
            selectedObservationTypes: [],
            fields: [
                { field: 'id', title: this.$t('observations.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                { field: 'created_time', title: this.$t('observations.created_time'), sort: true, headerClass: 'routa-table-header'},
                { field: 'type_name', title: this.$t('observations.type'), sort: true, headerClass: 'routa-table-header'},
                { field: 'group_name', title: this.$t('observations.group'), sort: true, headerClass: 'routa-table-header'},
                { field: 'length', title: this.$t('observations.length'), sort: true, headerClass: 'routa-table-header'},
                { field: 'road_direction', title: this.$t('observations.direction'), sort: true, headerClass: 'routa-table-header'},
                { field: 'geometry_type', title: this.$t('observations.geometry_type'), sort: true, headerClass: 'routa-table-header'},
                { field: 'road_number', title: this.$t('observations.road_number'), sort: true, headerClass: 'routa-table-header'},
                { field: 'section_number', title: this.$t('observations.road_section_number'), sort: true, headerClass: 'routa-table-header'},
                { field: 'distance_from_sec_start', title: this.$t('observations.distance_from_sec_start'), sort: true, headerClass: 'routa-table-header'},
                { field: 'road_section_length', title: this.$t('observations.road_section_length'), sort: true, headerClass: 'routa-table-header'},
                { field: 'order', title: this.$t('observations.order'), sort: true, headerClass: 'routa-table-header'},
                { field: 'reporter', title: this.$t('observations.reporter'), sort: true, headerClass: 'routa-table-header'},
                { field: 'city', title: this.$t('observations.city'), sort: true, headerClass: 'routa-table-header'},
                { field: 'street_name', title: this.$t('observations.street_name'), sort: true, headerClass: 'routa-table-header'},
                { field: 'status', title: this.$t('observations.status'), sort: true, headerClass: 'routa-table-header'},
                { field: 'info', title: this.$t('work_report.info'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    watch: {
        observations() {
            this.initTableItems()
        },
        selectedObservationTypes() {
            this.initTableItems()
        }
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    mounted: function () {
        this.initTableItems()
    },
    methods: {
        initTableItems: function () {
            this.tableItems = []
            const temp = []
            this.observations.forEach(function (observation) {
                if (observation.can_edit === true) {
                    observation.created_time = this.setTime(observation.created_time)
                    if (observation.closed_time !== undefined) {
                        observation.closed_time = this.setTime(observation.closed_time)
                    }
                    let contract = observation.contract ? observation.contract.name : undefined
                    if (!contract && observation.work_order) {
                        contract = observation.work_order.contract_task_type.contract ? observation.work_order.contract_task_type.contract.name : '-'
                    }
                    if (this.selectedObservationTypes.length === 0 || this.selectedObservationTypes.some(function (selectedType) {
                        return observation.type.id === selectedType.id;
                    })) {
                        temp.push({
                            id: observation.id,
                            reporter: observation.reporter.first_name + ' ' + observation.reporter.last_name,
                            type_name: observation.type.name,
                            type_id: observation.type.id,
                            group_name: observation.type.observation_group.name,
                            geometry_type: observation.type.geometry_type === 1 ? this.$t('observations.point') : this.$t('observations.line'),
                            length: observation.length ? observation.length : '',
                            created_time: this.toLocalTime(observation.created_time),
                            closed_time: this.toLocalTime(observation.closed_time),
                            city: observation.city ? observation.city.name : '',
                            street_name: observation.street_name ? observation.street_name : '',
                            road_number: observation.road_number ? observation.road_number : '',
                            section_number: observation.section_number ? observation.section_number : '',
                            distance_from_sec_start: observation.distance_from_sec_start ? observation.distance_from_sec_start : '',
                            road_section_length: observation.road_section_length ? observation.road_section_length : '',
                            contract: contract,
                            order: observation.work_order ? observation.work_order.task_type.name : '',
                            status: (observation.closed_time ? this.$t('observations.closed') : this.$t('observations.open')),
                            observation_group: observation.type.observation_group.name,
                            road_direction: observation.road_direction,
                            road_lane: observation.road_lane,
                            info: observation.info ? observation.info : ''
                        })
                    }
                }
            }, this)
            this.$nextTick(() =>  {
                this.tableItems = temp
            })
        },
        onRowClicked(item) {
            this.$emit('observationSelected', item)
        },
        exportExcel: function () {
            this.loading = true
            this.restGetDownloadFile(this.observationReportUrl, this.getCommonReportParams(this.params), this.excelDownloadSuccess, this.fileDownloadFail)
        },
        excelDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('observations.report_file_name'))
        },
        fileDownloadFail: function () {
            this.loading = false
            this.showAlert(this.$t('common.report_generation_failed'))
        },
        exportRoadReport: function () {
            this.loading = true
            this.restGetDownloadFile(this.observationRoadReportUrl, this.getCommonReportParams(this.params), this.roadReportDownloadSuccess, this.fileDownloadFail)
        },
        roadReportDownloadSuccess: function (response) {
            this.loading = false
            this.downloadFile(response, this.$t('observations.road_report_file_name'))
        }
    }
}
</script>
